export default "__VITE_ASSET__vCQZZrmz__"